import React, { Component } from 'react';
import { connect } from 'react-redux';
import moment from 'moment-timezone';
import { isEmpty } from 'lodash';

import TextField from "@mui/material/TextField";
import Button from "@mui/material/Button";
import Card from "@mui/material/Card";
import CardActions from '@mui/material/CardActions';
import Grid from "@mui/material/Grid";
import MenuItem from "@mui/material/MenuItem";
import { withStyles } from "@mui/styles";
import { DataGrid } from '@mui/x-data-grid';

import { client } from '../actions/client';
import PushJobsGrid from '../containers/PushJobsGrid';
import {
  pushOrder,
  unlockOrder,
  updateFromAM,
  relaxEdits,
  setToNeedsUpdate,
  setToUpdated,
  restoreDeletedOrder
} from "../actions/orderActions";
import { pushPlacements, saveAndPushPlacements, fixPlacements, fixPubs, fixName, fixAmid, clearOldStuff, clearSubcat } from "../actions/placementActions";
import { putAdvertisers, updateDelivery } from "../actions/advertisersActions";
import { uploadTargeting } from "../actions/presetActions";
import { uploadProducts } from "../actions/creativeProductActions";
import { startIndexJob } from "../actions/searchActions";
import { getConstants } from "../actions/constantActions";
import { uploadGeogroups } from "../actions/geogroupsActions";
import { updateKeyValues, updateGamCache } from "../actions/keyValueActions";

const tzNY = 'America/New_York';
const setStart = dt => moment.tz(dt, tzNY).startOf('day').format();

const MAX_PUSH_JOBS = 50;

const styles = (theme) => ({
  root: {
    minWidth: 250,
    maxWidth: 1000,
    marginLeft: 8,
    marginBottom: 16
  },
  title: {
    fontSize: 24,
    marginLeft: 16
  },
  card: {
    marginLeft: 12,
    marginRight: 12,
    paddingLeft: 16,
    paddingRight: 16,
    paddingBottom: 16,
  },
});

const pFields = [
  'dfpStatus',
  'start'
];

const columnsDO = [
  { field: 'id', headerName: 'ID', width: 90 },
  { field: 'agencyOrderName', headerName: 'Order Name', width: 200 },
  { field: 'agencyOrderId', headerName: 'Order ID', width: 200 },
  { field: 'AdvertiserId', headerName: 'Adv. ID', width: 150 },
  { field: 'deletedAt', headerName: 'Deleted At', width: 180 },
];

class Admin extends Component {

  constructor(props) {
    super(props);
    this.state = {
      orderId: '',
      delOrderId: '',
      placementIds: '',
      amsg: '',
      omsg: '',
      pmsg: '',
      tmsg: '',
      smsg: '',
      issue: '',
      dmsg: '',
      rmsg: '',
      fixingValue: false,
      pValue: '',
      pickedField: 'dfpStatus',
      user: localStorage.getItem('user'),
      deletedOrders: null,
      geogroupData: null,
      geogroupError: null,
      keyType: ''
    };
  }

  state = {
    pushJobs: null
  };

  componentDidMount() {
    document.body.style.overflowY = 'scroll';
    const { dispatch, constants } = this.props;
    if (isEmpty(constants)) {
      dispatch(getConstants());
    }
  }

  onChange = (evt) => {
    if (evt.target.name === 'orderId') {
      this.setState({ orderId: evt.target.value });
    } else if (evt.target.name === 'placementIds') {
      this.setState({ placementIds: evt.target.value });
    } else if (evt.target.name === 'issue') {
      this.setState({ issue: evt.target.value });
    } else if (evt.target.name === 'value') {
      this.setState({ pValue: evt.target.value });
    } else if (evt.target.name === 'delOrderId') {
      this.setState({ delOrderId: evt.target.value });
    }
  };

  getAdvertisers = (evt) => {
    const { dispatch } = this.props;
    dispatch(putAdvertisers()).then(() => {
      this.setState({ amsg: 'Advertisers updated from Ad Manager' });
    });
  };

  getKeyValues = (evt) => {
    const { dispatch } = this.props;
    if (this.state.keyType === 'audseg' || this.state.keyType === 'all') {
      this.setState({ amsg: 'Audience segment update takes several minutes' });
    }
    dispatch(updateKeyValues(this.state.keyType)).then(() => {
      this.setState({ amsg: 'Key/Values updated from Ad Manager' });
    });
  };

  updateGamCache = (evt) => {
    const { dispatch } = this.props;
    dispatch(updateGamCache()).then(() => {
      this.setState({ amsg: 'Cache values updated from Ad Manager' });
    });
  };

  updateDelivery = (evt) => {
    const { dispatch } = this.props;
    dispatch(updateDelivery()).then(() => {
      this.setState({ amsg: 'Delivery data updated from Ad Manager' });
    });
  };

  clearStuff = (evt) => {
    const { dispatch } = this.props;
    dispatch(clearOldStuff()).then(() => {
      this.setState({ amsg: 'Old data deleted from Galileo' });
    });
  };

  clearSubcat = (evt) => {
    const { dispatch } = this.props;
    dispatch(clearSubcat()).then(() => {
      this.setState({ amsg: 'Subcats cleared from Galileo' });
    });
  };

  updateFromAM = (evt) => {
    if (this.state.orderId && !isNaN(this.state.orderId.trim())) {
      const { dispatch } = this.props;
      dispatch(updateFromAM(this.state.orderId)).then(() => {
        this.setState({ omsg: 'IDs on order updated from Ad Manager' });
      })
    } else {
      this.setState({ omsg: 'Enter a numeric order ID' });
    }
  };

  relaxEdits = (evt) => {
    if (this.state.orderId && !isNaN(this.state.orderId.trim())) {
      const { dispatch } = this.props;
      dispatch(relaxEdits(this.state.orderId)).then(() => {
        this.setState({ omsg: 'Edits relaxed on order' });
      })
    } else {
      this.setState({ omsg: 'Enter a numeric order ID' });
    }
  };

  pushOrder = (evt) => {
    if (this.state.orderId && !isNaN(this.state.orderId.trim())) {
      const { dispatch } = this.props;
      dispatch(pushOrder(this.state.orderId)).then(() => {
        this.setState({ omsg: 'Order pushed to Ad Manager' });
      })
    } else {
      this.setState({ omsg: 'Enter a numeric order ID' });
    }
  };

  unlockOrder = (evt) => {
    if (this.state.orderId && !isNaN(this.state.orderId.trim())) {
      const { dispatch } = this.props;
      dispatch(unlockOrder(this.state.orderId)).then(() => {
        this.setState({ omsg: 'Order unlocked' });
      })
    } else {
      this.setState({ omsg: 'Enter a numeric order ID' });
    }
  };

  setToNeedsUpdate = (evt) => {
    if (this.state.orderId && !isNaN(this.state.orderId.trim())) {
      const { dispatch } = this.props;
      dispatch(setToNeedsUpdate(this.state.orderId)).then(() => {
        this.setState({ omsg: 'Statuses updated to NEEDS_UPDATE' });
      })
    } else {
      this.setState({ omsg: 'Enter a numeric order ID' });
    }
  };

  setToUpdated = (evt) => {
    if (this.state.orderId && !isNaN(this.state.orderId.trim())) {
      const { dispatch } = this.props;
      dispatch(setToUpdated(this.state.orderId)).then(() => {
        this.setState({ omsg: 'Statuses updated to UPDATED' });
      })
    } else {
      this.setState({ omsg: 'Enter a numeric order ID' });
    }
  };

  viewPushStatus = (evt) => {
   client.get( "/pushjobs").then(json => {
     const pushJobs = json.data.sort((a,b) => b.id - a.id).slice(0, MAX_PUSH_JOBS);
     this.setState({pushJobs: pushJobs})
    });
  };

  pushPlacements = (evt) => {
    const pids = this.scrubPlacements(this.state.placementIds);
    if (pids.length > 0) {
      const { dispatch } = this.props;
      dispatch(pushPlacements(pids)).then(() => {
        this.setState({ pmsg: 'Placements pushed' });
      })
    } else {
      this.setState({ pmsg: 'Enter comma-separated list of numeric placement IDs' });
    }
  };

  bulkPlacements = (evt) => {
    const { dispatch } = this.props;
    dispatch(saveAndPushPlacements()).then(() => {
      this.setState({ pmsg: 'Placements pushed' });
    })
  };

  onPickField = (evt) => {
    this.setState({ pickedField: evt.target.value });
  }

  onChangeKey = (evt) => {
    this.setState({ keyType: evt.target.value, amsg: '' });
  }

  onGeogroupsFileChanged = async (e) => {
    const file = e.target.files[0];
    const reader = new FileReader();
    reader.onloadend = async (evt) => {
      const csvString = evt.target.result;
      const geogroupData = csvString;
      this.setState({ geogroupData, geogroupError: null});
    }
    await reader.readAsText(file);
    //this.setState({ ...this.state,  uploadedFileName: file.name});
  }

  uploadGeogroups = async (evt) => {
    const { dispatch } = this.props;
    await dispatch(uploadGeogroups(this.state.geogroupData));
    const { result } = this.props.geogroupsRequest;
    const filename = "upload-geogroups-results.csv";
    const data = "data:text/csv;charset=utf-8," + encodeURIComponent(result);
    const link = document.createElement('a');
    link.setAttribute('href', data);
    link.setAttribute('download', filename);
    link.click();
  }

  fixPlacementValue = (evt) => {
    this.setState({ fixingValue: true });
  }

  applyPlacementValue = (evt) => {
    const { pickedField, pValue } = this.state;
    const pids = this.scrubPlacements(this.state.placementIds);
    if (pids.length > 0) {
      const { dispatch } = this.props;
      const value = (pickedField === 'start') ? setStart(moment.utc(pValue).set({ h: 10, m: 0 }).format()) : pValue;
      dispatch(fixPlacements(pids, pickedField, value)).then(() => {
        this.setState({ pickedField: 'dfpStatus', pValue: '', fixingValue: false, pmsg: 'Placements updated' });
      })
    } else {
      this.setState({ pmsg: 'Enter comma-separated list of numeric placement IDs' });
    }
  }

  /**
   * Removes publications from placements
   * You can enter a set of placement IDs, or enter 'file' to refer to a file of IDs in the order-manager code.
   * @param evt
   */
  fixPubs = (evt) => {
    const { dispatch } = this.props;
    dispatch(fixPubs()).then(() => {
      this.setState({ pmsg: 'Placements have been saved' });
    })
  }

  fixAmid = (evt) => {
    console.log('fix amid--------------------');
    const { dispatch } = this.props;
    dispatch(fixAmid('12345', 'abc123' )).then(() => {
      this.setState({ pmsg: 'AM IDs have been fixed' });
      console.log('fix amid done');
    })
    console.log('fix amid failed');
  }

  /**
   * The fixName button changes Hybrid to EV/Hybrid in the line item name.
   * Placement ids to fix are read from a file.
   * This is a one-off job.
   * @param evt
   */
  fixName = (evt) => {
    const { dispatch } = this.props;
    dispatch(fixName()).then(() => {
      this.setState({ pmsg: 'Names have been fixed' });
    })
  }

  uploadTargeting = (evt) => {
    const { dispatch } = this.props;
    dispatch(uploadTargeting()).then(() => {
      this.setState({ tmsg: 'presets uploaded' });
    })
  }

  uploadProducts = (evt) => {
    const { dispatch } = this.props;
    dispatch(uploadProducts()).then(() => {
      this.setState({ tmsg: 'products uploaded' });
    })
  }

  scrubPlacements = (placements) => {
    const dirtyPlacements = placements.split(',');
    return dirtyPlacements.map(p => p.trim()).filter(p => !isNaN(p));
  }

  indexAdvertisers = () => {
    const { dispatch } = this.props;
    dispatch(startIndexJob('advertiser'));
    this.setState({ smsg: 'Advertiser index updated' });
  }

  indexIos = () => {
    const { dispatch } = this.props;
    dispatch(startIndexJob('io'));
    this.setState({ smsg: 'IO index updated' });
  }

  indexPlacements = () => {
    const { dispatch } = this.props;
    dispatch(startIndexJob('placement'));
    this.setState({ smsg: 'Updating placement index' });
  }

  clearIndices = () => {
    const { dispatch } = this.props;
    dispatch(startIndexJob('clear'));
    this.setState({ smsg: 'All indices cleared' });
  }

  invokeReport = (endpoint) => {
    const url = `${window.runConfig.REACT_APP_API_URL}/${endpoint}`
    fetch(url)
      .then(response => response.json())
      .then(data => {
        this.setState({ rmsg: 'Report has run' });
      });
  };

  fetchDeletedOrders = () => {
    client.get( "/ios/fetchDeletedOrders").then(dos => {
      const deletedOrders = dos.data.sort((a, b) => a.id - b.id);
      this.setState({ deletedOrders: deletedOrders })
    });
  };

  restoreDeletedOrder = (evt) => {
    if (this.state.delOrderId && !isNaN(this.state.delOrderId.trim())) {
      const { dispatch } = this.props;
      dispatch(restoreDeletedOrder(this.state.delOrderId)).then(() => {
        this.setState({ dmsg: 'Order restored' });
      })
    } else {
      this.setState({ dmsg: 'Enter a numeric deleted order ID' });
    }
  };

  render() {
    const { pushJobs, user, deletedOrders, keyType } = this.state;
    const { classes, constants } = this.props;
    const pushStatus = pushJobs ? <PushJobsGrid pushJobs={pushJobs}/> : '';
    const forbiddenPage = (constants && !constants.whitelistedDevs.includes(user));

    return (
      <div>
        <h1 className={classes.title}>Galileo Admin</h1>

        {forbiddenPage &&
          <Card className={classes.card}>
            <h2>Forbidden page</h2>
            <p>You don't have permission to access the admin page</p>
          </Card>
        }

        {!forbiddenPage &&
          <div>
            <Card className={classes.card}>
              <h2>Targeting/Product Data</h2>
              <p>Update Galileo with latest targeting or product data from S3</p>
              <CardActions>
                <Button variant="contained" onClick={this.uploadTargeting}>Upload Targeting Presets</Button>
                <Button variant="contained" onClick={this.uploadProducts}>Upload Sales/Creative Products</Button>
              </CardActions>
              <p>{this.state.tmsg}</p>
            </Card>
            <br/>

            <Card className={classes.card}>
              <h2>Google Ad Manager</h2>
              <p>Galileo-wide: Update advertisers or key/values or delivery data from Ad Manager</p>
              <CardActions>
                <Button variant="contained" onClick={this.getAdvertisers}>Update Advertisers</Button>
                <Button variant="contained" onClick={this.getKeyValues}>Update Key/Values</Button>
                <Button variant="contained" onClick={this.updateGamCache}>Update GAM Cache</Button>
                <Button variant="contained" onClick={this.updateDelivery}>Update Delivery Data</Button>
              </CardActions>
              <p>{this.state.amsg}</p>
              <TextField
                variant="standard"
                fullWidth
                select
                name="packageType"
                onChange={this.onChangeKey}
                margin="normal"
                label="Key"
                value={keyType}
                SelectProps={{
                  MenuProps: {
                    className: classes.menu
                  }
                }}>
                {constants && constants.kvKeyList.map(type => (
                  <MenuItem key={type} value={type}>
                    {type}
                  </MenuItem>
                ))}
              </TextField>
            </Card>
            <br/>

            <Card className={classes.card}>
              <h2>Orders</h2>
              <p>For selected order: Push to GAM OR unlock OR get IDs from GAM OR disable date edits OR reset all statuses OR get all push statuses</p>
              <CardActions>
                <Button variant="contained" onClick={this.pushOrder}>Push Order</Button>
                <Button variant="contained" onClick={this.unlockOrder}>Unlock Order</Button>
                <Button variant="contained" onClick={this.updateFromAM}>Update AM IDs</Button>
                <Button variant="contained" onClick={this.relaxEdits}>Relax Date Edits</Button>
                <Button variant="contained" onClick={this.setToNeedsUpdate}>Set to Needs_Update</Button>
                <Button variant="contained" onClick={this.setToUpdated}>Set to Updated</Button>
                <Button variant="contained" onClick={this.viewPushStatus}>Push Status</Button>
              </CardActions>
              <TextField
                variant="standard"
                name="orderId"
                value={this.state.orderId}
                label="Order Id"
                onChange={this.onChange}
                error={this.state.omsg.length > 20}
                helperText={this.state.omsg || 'enter order ID'}
                fullWidth
                margin="normal" />
              {pushStatus}
            </Card>
            <br/>

            <Card className={classes.card}>
              <h2>Placements</h2>
              <p>For selected placement(s) on one order: Push to GAM OR run a custom job to fix fields on selected placements</p>
              <CardActions>
                <Button variant="contained" onClick={this.pushPlacements}>Push Placements</Button>
                <Button variant="contained" onClick={this.bulkPlacements}>Bulk Push Placements</Button>
                <Button variant="contained" onClick={this.fixPlacementValue}>Fix Value</Button>
                <Button variant="contained" onClick={this.fixPubs}>Fix Pubs</Button>
                <Button variant="contained" onClick={this.fixName}>Fix Name</Button>
                <Button variant="contained" onClick={this.fixAmid}>Fix AM ID</Button>
              </CardActions>
              {this.state.fixingValue === true && this.state.placementIds &&
                <>
                  <Grid container spacing={3}>
                    <Grid item xs={3}>
                      <TextField
                        variant="standard"
                        fullWidth
                        select
                        name="pField"
                        onChange={this.onPickField}
                        margin="normal"
                        label="Field"
                        value={this.state.pickedField}
                        SelectProps={{
                          MenuProps: {
                            className: classes.menu
                          }
                        }}>
                        {pFields.map(type => (
                          <MenuItem key={type} value={type}>
                            {type}
                          </MenuItem>
                        ))}
                      </TextField>
                    </Grid>
                    <Grid item xs={3}>
                      <TextField
                        variant="standard"
                        name="value"
                        value={this.state.pValue}
                        label="Value"
                        onChange={this.onChange}
                        fullWidth
                        margin="normal" />
                    </Grid>
                    <Grid item xs={3}>
                      <Button variant="contained" onClick={this.applyPlacementValue}>Apply</Button>
                    </Grid>
                  </Grid>
                </>
              }
              <TextField
                variant="standard"
                name="placementIds"
                value={this.state.placementIds}
                label="Placement Ids"
                multiline
                maxRows="6"
                onChange={this.onChange}
                error={this.state.pmsg.length > 20}
                helperText={this.state.pmsg || 'enter placement IDs, comma-separated'}
                fullWidth
                margin="normal" />
            </Card>
            <br/>

            <Card className={classes.card}>
              <h2>Reports</h2>
              <p>Click to produce reports</p>
              <CardActions>
                <Button variant="contained" onClick={() => this.invokeReport('reports/booked_revenue_rpt_this')}>Booked Revenue This Year</Button>
                <Button variant="contained" onClick={() => this.invokeReport('reports/booked_revenue_rpt_next')}>Booked Revenue Next Year</Button>
                <Button variant="contained" onClick={() => this.invokeReport('reports/booked_revenue_rpt_last')}>Booked Revenue Last Year</Button>
                <Button variant="contained" onClick={() => this.invokeReport('reports/past_start_dates')}>Past Start Dates</Button>
                <Button variant="contained" onClick={() => this.invokeReport('reports/booked_programmatic_rpt')}>Booked Programmatic</Button>
                <Button variant="contained" onClick={() => this.invokeReport('reports/daily_usage')}>Daily Usage</Button>
                <Button variant="contained" onClick={() => this.invokeReport('reports/mismatched_amids')}>Mismatched AMIDs</Button>
              </CardActions>
              <p>{this.state.rmsg}</p>
            </Card>
            <br/>

            <Card className={classes.card}>
              <h2>Deleted Orders</h2>
              <p>Deleted orders: Enter ID to restore</p>
              <CardActions>
                <Button variant="contained" onClick={this.fetchDeletedOrders}>Get Deleted Orders</Button>
                <Button variant="contained" onClick={this.restoreDeletedOrder}>Restore Order</Button>
                <Button variant="contained" onClick={this.clearStuff}>Clear Obsolete Data</Button>
                <Button variant="contained" onClick={this.clearSubcat}>Clear Subcategory</Button>
              </CardActions>
              <TextField
                variant="standard"
                name="delOrderId"
                value={this.state.delOrderId}
                label="Deleted Order Id"
                onChange={this.onChange}
                error={this.state.dmsg.length > 20}
                helperText={this.state.dmsg || 'enter deleted order ID'}
                fullWidth
                margin="normal" />
              {deletedOrders && <div style={{height: 400, width: '100%'}}>
                <DataGrid
                  rows={deletedOrders}
                  columns={columnsDO}
                  title={'Deleted Orders'}
                />
              </div>
              }
            </Card>
            <br/>

            <Card className={classes.card}>
              <h2>Geogroups</h2>
              <p>Upload geogroups definitions</p>
              <TextField
                name="geogroups"
                type="file"
                accept="text/csv"
                onChange={this.onGeogroupsFileChanged}
              />
              <CardActions>
                <Button variant="contained" onClick={this.uploadGeogroups}>Upload Geogroups</Button>
              </CardActions>
              <p>{this.state.geogroupMsg}</p>
            </Card>
            <br/>

            <Card className={classes.card}>
              <h2>Search</h2>
              <p>Update ElasticSearch indices</p>
              <CardActions>
                <Button variant="contained" onClick={this.indexAdvertisers}>Advertisers</Button>
                <Button variant="contained" onClick={this.indexIos}>IOs</Button>
                <Button variant="contained" onClick={this.indexPlacements}>Placements</Button>
                <Button variant="contained" onClick={this.clearIndices}>Clear All</Button>
              </CardActions>
              <p>{this.state.smsg}</p>
            </Card>
            <br/>

          </div>
        }
      </div>
    );
  }
}

const mapStateToProps = state => {
  const { dispatch, orderRequest, constantRequest, geogroupsRequest } = state;
  return {
    dispatch,
    constants: constantRequest.constants,
    pushResult: ((orderRequest || {})).pushResult,
    geogroupsRequest
  }
};

export default withStyles(styles)(connect(mapStateToProps)(Admin));
